const projectGalleryFilters = `
  projectsListFilterSip
  projectsListFilter3rd5thClub
  projectsListFilter6th12thClub
  projectsListFilterCampus
  projectsListFilterCollegeLoop
`;

export default projectGalleryFilters;
